import React from 'react';

import EditableConfigOptionDisplay from 'lab-automation/settings/EditableConfigOptionDisplay';
import {LookupConfigModalContextInfo} from 'lookup-config/LookupConfigModalConstants';
import {Schema} from 'schemas/SchemaConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

import {LookupConfigDescription} from './LookupConfigDescription';
import {LookupConfigSpec} from './LookupConfigModalConstants';

interface LookupConfigDisplayProps {
  baseSchema: Schema | null;
  lookupConfig: LookupConfigSpec;
  lookupConfigLabel?: string;
  context?: LookupConfigModalContextInfo;
  editTestAttrs?: DataTestAttrs;
  removeTestAttrs?: DataTestAttrs;
  lookupConfigDescriptionTestAttrs?: DataTestAttrs;
  onEdit: () => void;
  onRemove: () => void;
  lookupType: string;
  isDisabled?: boolean;
}

export default function EditableLookupConfigDisplay(props: LookupConfigDisplayProps): JSX.Element {
  return (
    <EditableConfigOptionDisplay
      disabled={props.isDisabled}
      onEdit={props.onEdit}
      onRemove={props.onRemove}
      editButtonLabel={`Edit ${props.lookupType} lookup`}
      removeButtonLabel={`Remove ${props.lookupType} lookup`}
      dataTestAttrs={props.lookupConfigDescriptionTestAttrs}
      editTestAttrs={props.editTestAttrs}
      removeTestAttrs={props.removeTestAttrs}
    >
      <LookupConfigDescription
        baseSchema={props.baseSchema}
        lookupConfig={props.lookupConfig}
        label={props.lookupConfigLabel}
        context={props.context}
      />
    </EditableConfigOptionDisplay>
  );
}
